<ng-container *ngIf="customStyle" >
    <mat-accordion>
        <mat-expansion-panel [expanded]="false" >
          <mat-expansion-panel-header>
            <mat-panel-title>
              Description
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="description-style" >
            <div class="text" [innerText]="customStyle.description" > </div>
            <div class="image">
                <img [src]="environment.backend+customStyle.icon">
              </div>
        </div>
        </mat-expansion-panel>
    </mat-accordion>
    
</ng-container>

<div fxLayout="column" class="polygon-simple-form" >

  <app-color-picker [colorOutputFormat]="'hex'" [colorLabel]=" 'admin.symbology.line.lineColor' | translate " [colorForm]="form.get('lineColor')" ></app-color-picker>

  <mat-form-field appearance="legacy" style="width: 100%;" >
    <mat-label> {{'admin.symbology.line.lineWidth' | translate }} </mat-label>
    <input matInput type="number" [formControl]="form.get('lineWidth')" name="lineWidth" >
  </mat-form-field>



</div>